'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _vuStyleSheet = require('@ali/vu-style-sheet');

var _vuStyleSheet2 = _interopRequireDefault(_vuStyleSheet);

var _utils = require('./utils');

require('./view.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

var Column = (_temp = _class = function (_React$Component) {
  _inherits(Column, _React$Component);

  function Column() {
    _classCallCheck(this, Column);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Column.prototype.render = function render() {
    var _props = this.props,
        componentId = _props.componentId,
        flex = _props.flex,
        children = _props.children,
        layoutGap = _props.layoutGap,
        childrenLen = _props.childrenLen,
        childrenIndex = _props.childrenIndex,
        breakpoint = _props.breakpoint;


    var style = (0, _utils.applyLayoutGapToStyle)(false, '', layoutGap, this.props.style || {}, childrenLen, childrenIndex);
    var __style__ = this.props.__style__ || {};
    var className = (0, _classnames2.default)('vc-gov-columns-layout-column next-col next-col-' + flex);
    return _react2.default.createElement(
      'div',
      { id: componentId, className: className, style: _extends({}, __style__, style) },
      children
    );
  };

  return Column;
}(_react2.default.Component), _class.propTypes = {
  flex: _propTypes2.default.string,
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  componentId: _propTypes2.default.string,
  childrenLen: _propTypes2.default.number,
  childrenIndex: _propTypes2.default.number,
  layoutGap: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
}, _class.displayName = 'Column', _temp);
var ColumnsLayout = (_temp2 = _class2 = function (_React$Component2) {
  _inherits(ColumnsLayout, _React$Component2);

  function ColumnsLayout() {
    _classCallCheck(this, ColumnsLayout);

    return _possibleConstructorReturn(this, _React$Component2.apply(this, arguments));
  }

  ColumnsLayout.prototype.render = function render() {
    var _this3 = this;

    var _props2 = this.props,
        componentId = _props2.componentId,
        style = _props2.style,
        visible = _props2.visible,
        disableFieldSelect = _props2.disableFieldSelect;

    var layout = (this.props.layout || '24').split(':');
    var childrenLen = 0; // 分栏个数
    var breakpoint = this.props.breakpoint || 'xs';
    if (this.props.children && this.props.children.length) {
      childrenLen = this.props.children.length;
    }
    var children = _react2.default.Children.map(this.props.children, function (child, i) {
      return _react2.default.cloneElement(child, {
        flex: layout[i],
        childrenLen: childrenLen,
        childrenIndex: i,
        breakpoint: breakpoint,
        layoutGap: _this3.props.layoutGap,
        disableFieldSelect: disableFieldSelect // 透传表单选择模式禁用态，为了做到复杂组件中引入布局组件导致被嵌套的基础组件出现表单选择模式
      });
    });

    var __style__ = this.props.__style__;
    var className = (0, _classnames2.default)('next-row', _vuStyleSheet2.default.invoke('.' + componentId, style, this.props.className), {
      'vc-form-item-hidden': visible === false
    });

    return _react2.default.createElement(
      'div',
      { id: componentId, className: className, style: _extends({}, __style__, style) },
      children
    );
  };

  return ColumnsLayout;
}(_react2.default.Component), _class2.propTypes = {
  className: _propTypes2.default.string,
  layout: _propTypes2.default.string,
  children: _propTypes2.default.node,
  style: _propTypes2.default.object,
  breakpoint: _propTypes2.default.string,
  componentId: _propTypes2.default.string,
  layoutGap: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number])
}, _class2.displayName = 'ColumnsLayout', _temp2);
exports.default = [ColumnsLayout, Column];
module.exports = exports['default'];